
      import Zhihu from './zhihu.vue'
      import type { App, Plugin } from 'vue'

      export const ZhihuPlugin: Plugin = {
        install(app: App) {
          app.component('Zhihu', Zhihu)
        },
      }
      export { Zhihu }
      